import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

class General extends Component {
    
   public render(){             
        return(
            <div className="app-container">
                <div className="app-content">
                    {this.props.children}
                </div>
            </div> 
        );
    }
}
export default withRouter((General) as any);

